// extracted by mini-css-extract-plugin
export var backdropBlur = "_fm-0";
export var contentCard = "_fm-5";
export var frame = "_fm-2";
export var image = "_fm-4";
export var imagePane = "_fm-3";
export var modal = "_fm-1";